(() => {
  if (customElements.get('vm-model-browser')) return;
  class VeltonaModelBrowser extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-open]');
      if (!dialog || !opener || !dialog.showModal) return;
      this.ready = true;
      this.dialog = dialog;
      const cards = [...dialog.querySelectorAll('[data-model]')];
      const filters = [...dialog.querySelectorAll('[data-filter]')];
      const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
      this.querySelectorAll('a[href]').forEach(link => {
        if (preview && /^\d+$/.test(preview) && window.Shopify?.theme?.role === 'unpublished' && String(window.Shopify.theme.id) === preview) {
          const url = new URL(link.href, location.href);
          url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        }
        if (link.dataset.model) link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          if (link.getAttribute('aria-current') === 'page') { event.preventDefault(); dialog.close(); }
        });
      });
      const applyFilter = value => {
        let count = 0;
        cards.forEach(card => {
          const show = value === 'all' || card.dataset.band === value || (value === 'arabic' && card.dataset.arabic === 'true');
          card.hidden = !show;
          if (show) count++;
        });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
        dialog.querySelector('[data-count]').textContent = value === 'all' ? `${count} models` : `${count} of ${cards.length} models`;
        dialog.querySelector('[data-empty]').hidden = count !== 0;
        dialog.querySelector('.vm-model-dialog__body').scrollTop = 0;
      };
      filters.forEach(button => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', dialog.id);
      opener.setAttribute('aria-expanded', 'false');
      opener.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (dialog.open) return;
        applyFilter('all');
        this.oldOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-close]').focus({preventScroll: true});
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.oldOverflow || '';
        opener.setAttribute('aria-expanded', 'false');
        if (opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const stops = [...dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')].filter(node => node.getClientRects().length && !node.closest('[hidden]'));
        const first = stops[0], last = stops[stops.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const b = dialog.getBoundingClientRect();
        if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
      });
      this.dataset.ready = 'true';
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow || ''; }
    }
  }
  customElements.define('vm-model-browser', VeltonaModelBrowser);
})();
